class SubscriptionDropdown {
  constructor() {
    this.cartUpdateUnsubscriber = undefined;
    this.init();
  }
  
  init() {
    this.initializeDropdowns();
    document.addEventListener('click', this.handleOutsideClick.bind(this));
    
    if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(() => {
          this.initializeDropdowns();
        }, 100);
      });
    }
    
    document.addEventListener('cart-drawer:open', () => {
      setTimeout(() => {
        this.initializeDropdowns();
      }, 100);
    });

    document.addEventListener('bundle:added', (event) => {
      setTimeout(() => {
        this.initializeDropdowns();
      }, 200);
    });

    document.addEventListener('jar-gift:added', (event) => {
      setTimeout(() => {
        this.initializeDropdowns();
      }, 200);
    });
  }

  initializeDropdowns() {
    this.closeAllDropdowns();
    
    const dropdowns = document.querySelectorAll('.subscription-dropdown');
    if (!dropdowns.length) return;

    dropdowns.forEach(dropdown => {
      if (dropdown.dataset.initialized) return;
      
      dropdown.dataset.initialized = 'true';
      
      const dropdownButton = dropdown.querySelector('.subscription-dropdown__button');
      if (!dropdownButton) return;
      
      const currentSellingPlanName = dropdownButton.textContent.trim();
        dropdownButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        this.closeAllDropdowns(dropdown);
        dropdown.classList.toggle('_is-active');
      });
      
      const dropdownItems = dropdown.querySelectorAll('.subscription-dropdown__item');
      dropdownItems.forEach(item => {
        if (item.textContent.trim() === currentSellingPlanName) {
          item.classList.add('_is-selected');
        }
        
        item.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          
          if (item.classList.contains('_is-selected')) {
            dropdown.classList.remove('_is-active');
            return;
          }
          
          const cartItems = dropdown.closest('cart-items') || dropdown.closest('cart-drawer-items');
          const lineItemQty = dropdown.dataset.lineItemQty;
          const sellingPlanId = item.dataset.sellingPlanId;
          const lineItemIndex = dropdown.dataset.lineItemIndex;          
          
          if (cartItems && sellingPlanId && lineItemIndex && lineItemQty) {
            this.closeAllDropdowns();
            dropdown.classList.add('_is-loading');
            cartItems.updateQuantity(lineItemIndex, lineItemQty, 'update', sellingPlanId);
          }
        });
      });
    });
  }
       
  handleOutsideClick(event) {
    const dropdowns = document.querySelectorAll('.subscription-dropdown._is-active');
    
    dropdowns.forEach(dropdown => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('_is-active');
      }
    });
  }
  
  closeAllDropdowns(exceptDropdown = null) {
    const activeDropdowns = document.querySelectorAll('.subscription-dropdown._is-active');
    
    activeDropdowns.forEach(dropdown => {
      if (exceptDropdown && dropdown === exceptDropdown) return;
      dropdown.classList.remove('_is-active');
    });
  }

  disconnect() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.subscriptionDropdown = new SubscriptionDropdown();
});
